import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";







@Injectable({ providedIn: 'root' })
export class ChatRoomService
{


    constructor(
        private http : HttpClient
    ){}


    send_user_reply(user_reply : string , ticket_id : number)
    {

        return this.http.post(`${environment.api_url}/tickets/addCustomerReply`, {
            message: user_reply,
            ticket_id: ticket_id
        });

    }

}